import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {HttpService} from '../../../../core';
import {ToastrService} from 'ngx-toastr';
import {timer} from 'rxjs';
import {finalize, map, take} from 'rxjs/operators';

@Component({
  selector: 'app-email-verification',
  templateUrl: './email-verification.component.html',
  styleUrls: ['./email-verification.component.scss']
})
export class EmailVerificationComponent implements OnInit {
  email = '';
  countdown: number;
  isCountingDown = false;
  isDisable = false;

  constructor(public dialogRef: MatDialogRef<EmailVerificationComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,
              private httpService: HttpService,
              private toast: ToastrService) {
  }

  ngOnInit(): void {
    console.log('---data---', this.data);
    this.email = this.data.record;
  }

  onClose() {
    this.dialogRef.close();
  }

  onResendEmail() {
    this.isDisable = true;
    const fd = new FormData();
    fd.append('userEmail', this.email);
    fd.append('terminal_type', 'DEVELOPER');
    this.httpService.resendEmail(fd)
      .pipe(finalize(() => {
        this.isDisable = false;
      }))
      .subscribe(
        res => this.handleResendEmail(res)
      );
  }

  handleResendEmail(res: any) {
    if (res.code === 1) {
      this.displaySuccessMessage();
      this.startCountdown();
    } else {
      this.displayErrorMessage();
    }
  }

  displaySuccessMessage() {
    this.toast.success('Email sent successfully.');
  }

  displayErrorMessage() {
    this.toast.error('Failed to resend email. Please try again later.');
  }

  startCountdown() {
    this.isCountingDown = true;
    const countdownDuration = 60;
    const countdown$ = timer(0, 1000).pipe(
      take(countdownDuration + 1),
      map(seconds => countdownDuration - seconds)
    );

    countdown$.subscribe(
      (secondsRemaining) => {
        this.countdown = secondsRemaining;
      },
      null,
      () => {
        this.onCountdownComplete();
      }
    );
  }

  onCountdownComplete() {
    this.isCountingDown = false;
  }
}
